module.exports = __webpack_public_path__ + "static/media/cape-poster.96000c49.png";